import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import './History.css'
import Paper from '@mui/material/Paper';
import IntakeFormFields from '../../components/IntakeFormFields/IntakeFormFields';
import { autoPopulatedFields } from '../../utils/Data';

import StickyHeadTable from '../../components/StickyHeadTable/StickyHeadTable';
import { useState } from 'react';
import { Typography } from '@mui/material';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  maxHeight: '90vh', // Ensure modal doesn't exceed viewport height
  overflowY: 'auto',
};

interface Column {
  id: string;
  label: string;
  minWidth?: number;
  align?: 'right';
  format?: (value: any) => string;
}

const columns: Column[] = [
  { id: 'serialNumber', label: 'No.', minWidth: 50, },

{ id: 'requestedBy', label: 'Requested By', minWidth: 150 },
{ id: 'location', label: 'Location', minWidth: 150 },
{ id: 'manager', label: 'Manager', minWidth: 150 },
{ id: 'email', label: 'Email', minWidth: 150 },
{ id: 'financeEmail', label: 'Finance Email', minWidth: 150 },
{ id: 'supportingDocuments', label: 'Documents', minWidth: 150 },
];


interface Data {
  name: string;
  code: string;
  population: number;
  size: number;
  density: number;
}

function createData(
  name: string,
  code: string,
  population: number,
  size: number,
): Data {
  const density = population / size;
  return { name, code, population, size, density };
}

const  History = () =>{
  const [open, setOpen] = React.useState(false);
  const [formData, setFormData] = React.useState({});
  const [files, setFiles] = React.useState<FileList | null>(null);
  const [dataArray, setDataArray] = React.useState<any[]>([]);
  
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(false);
  const handleOpen = () => {
    setFormData({});
    setFiles(null);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);
  
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  
  const handleChange = (value: any, key: string) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };
  
  const handleFileChange = (files: FileList | null) => {
    setFiles(files);
  };

  
  const handleSave = () => {
    
    try {
      setLoading(true);
      const finalData = {
        ...formData,
        ...autoPopulatedFields,
        supportingDocuments: files ? Array.from(files) : [],
      };
      setDataArray((prev) => [...prev, finalData]);
      handleClose();
      setLoading(false);
    } catch (error : any) {
      setError(error);
    }
    
  };
  
  
  // const [formData, setFormData] = useState<{ [key: string]: any }>({});
  const [fileList, setFileList] = useState<FileList | null>(null);

  const handleFieldChange = (value: any, key: string) => {
    setFormData(prev => ({ ...prev, [key]: value }));
  };

  
  const fieldsConfig = [
    { id: 'name', label: 'Name', type: 'text' },
    { id: 'email', label: 'Email', type: 'text' },
    { id: 'dateOfBirth', label: 'Date of Birth', type: 'date' },
    { id: 'comments', label: 'Comments', type: 'textarea' },
    { id: 'status', label: 'Status', type: 'select', options: ['Active', 'Inactive'] }
  ];

  const fileUploadSections = [
    { id: 'resume', label: 'Upload Resume', allowedExtensions: ['pdf', 'doc', 'docx'], maxFiles: 1 },
    { id: 'coverLetter', label: 'Upload Cover Letter', allowedExtensions: ['pdf', 'doc', 'docx'], maxFiles: 1 }
  ];
  
  const handleEdit = (row: any) => {
    // You can add logic here to open a modal, navigate to an edit page, etc.
  };


  return (
    <div>
      <div className='top-bar'>
        {/* <Typography>Choose Your consulting Type</Typography> */}
         <button className='add-button' onClick={handleOpen}>
           + Add Task
         </button>
       </div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="modal-content">
          
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
            <Button onClick={handleClose} sx={{ mr: 2, fontFamily: '"Inter", sans-serif', color : '#6D7888', fontSize : '15px' }}>
              Cancel
            </Button>
            <Button variant="contained" onClick={handleSave} sx={{fontFamily: '"Inter", sans-serif', backgroundColor : "#004F9A", fontSize : '15px'}}>
              Save
            </Button>
            </Box>
        </Box>
      </Modal>
      <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      {/* <StickyHeadTable data={dataArray} columns={columns} onEdit={handleEdit}  /> */}
    </Paper>
    </div>
  );
}

export default History;



